/**
 * Toggling GEO watching affects all place data, which is most fetched data within the app.
 */
import _                                     from 'lodash';
import { calculateDistance, removeDistance } from './../classes/Distance';
import { setPlaces }                         from './../actions/PlacesAction';
import { setPlace }                          from './../actions/PlaceAction';
import { setClosest, resetClosest }          from './../actions/ClosestAction';

export const resetAppData = (dispatch, getState) =>
{
    let newPlaces = removeDistance(getState().places.items);
    dispatch(setPlaces(newPlaces));
    if (getState().place.id)
    {
        dispatch(setPlace(getState().place.id));
    }
    dispatch(resetClosest());
};

export const fetchAppData = (dispatch, getState) =>
{
    let places = getState().places.items;
    if (null !== getState().geo.coords)
    {
        places = calculateDistance(getState().geo.coords, places);
        let closest = _.head(places);
        dispatch(setClosest(closest));
    }

    dispatch(setPlaces(places));
    if (getState().place.id)
    {
        dispatch(setPlace(getState().place.id));
    }
};

export const getGoogleMap = (map) =>
{
    return map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
};

export const getBounds = () =>
{
    return new window.google.maps.LatLngBounds();
};

export const getLatLng = (lat, long) =>
{
    return new window.google.maps.LatLng(parseFloat(lat), parseFloat(long));
};



// WEBPACK FOOTER //
// ./src/classes/HandleGeo.js